import React from 'react';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';

import { featureFlagsSelectors } from 'app-components/flux/feature-flags';
import { tracker, getLogger } from 'app-components/utils/core';

const log = getLogger('ContentSecurityPolicy');

const CSP_VIOLATION_MAX_PER_HOUR = 60;
let cspViolationCount = 0;
let cspViolationWindowStart = Date.now();
document.addEventListener('securitypolicyviolation', (event) => {
  log.error('CSP Violation:', {
    type: event.type,
    status_code: event.statusCode,
    document_uri: event.documentURI,
    blocked_uri: event.blockedURI,
    violated_directive: event.violatedDirective,
    original_policy: event.originalPolicy,
  });

  const now = Date.now();
  if (now - cspViolationWindowStart > 60 * 60 * 1000) {
    cspViolationCount = 0;
    cspViolationWindowStart = now;
  }

  if (cspViolationCount < CSP_VIOLATION_MAX_PER_HOUR) {
    cspViolationCount += 1;

    tracker.track(tracker.events.securityPolicyViolation, {
      type: event.type,
      status_code: event.statusCode,
      document_uri: event.documentURI,
      blocked_uri: event.blockedURI,
      violated_directive: event.violatedDirective,
      original_policy: event.originalPolicy,
    });
  }
});

const ContentSecurityPolicy = () => {
  const contentSecurityPolicy = useSelector((state) =>
    // @ts-expect-error FIXME TS2345
    featureFlagsSelectors.getFeatureFlag(state, 'contentSecurityPolicy'),
  );
  const previewLabel = process.env.PREVIEW_LABEL;
  const titlePrefix = previewLabel ? `${previewLabel}: ` : '';
  return (
    <Helmet defaultTitle={`${titlePrefix}Simplifi`} titleTemplate={`${titlePrefix}Simplifi - %s`}>
      <meta name='description' content='Simplifi Web App' />
      <link rel='icon' href='favicon.ico' />
      <link rel='apple-touch-icon' href='apple-touch-icon.png' />
      <meta httpEquiv='Content-Security-Policy' content={contentSecurityPolicy} />
    </Helmet>
  );
};
export default ContentSecurityPolicy;
